import * as B from '@blueprintjs/core';
import * as I from 'immutable';
import React from 'react';
import ReactDOM from 'react-dom';

import {ApiOrganizationUser} from 'app/modules/Remote/Organization';
import {MapSettingsTool} from 'app/pages/MonitorProjectView/view';
import featureFlags from 'app/utils/featureFlags';
import * as mapUtils from 'app/utils/mapUtils';
import * as userUtils from 'app/utils/userUtils';

import MapContent from './MapContent';
import cs from './StyleControl.module.scss';

import {MapControlPosition} from '.';

interface Props {
  map: mapboxgl.Map;
  isMapLoaded: boolean;
  position: MapControlPosition;
  activeMapSettingsTool: MapSettingsTool | null;
  setActiveMapSettingsTool: (t: MapSettingsTool | null) => void;
  startsGroup?: boolean;

  /** Props to support toggling the hidden cost debugger layer */
  profile?: I.ImmutableOf<ApiOrganizationUser>;
  showCostDebugger?: boolean;
  setShowCostDebugger?: (b: boolean) => void;
}

export default class MapSettingsControl extends React.Component<Props> {
  private mapSettingsControlButtonEl = document.createElement('div');
  private mapSettingsControlButton = new mapUtils.PortalControl(
    this.mapSettingsControlButtonEl,
    this.props.startsGroup ? cs.groupStart : undefined
  );

  render() {
    const {
      map,
      isMapLoaded,
      position,
      activeMapSettingsTool,
      setActiveMapSettingsTool,
      showCostDebugger = false,
      setShowCostDebugger,
      profile,
    } = this.props;

    const canUseQuickMapVectorViewer = !!profile && featureFlags.QUICK_MAP_VECTOR_VIEWER(profile);

    return (
      <React.Fragment>
        <MapContent
          map={map}
          isMapLoaded={isMapLoaded}
          controls={[this.mapSettingsControlButton]}
          controlPosition={position}
        />
        {ReactDOM.createPortal(
          <B.ButtonGroup vertical>
            <B.Tooltip content="Change basemap" position={B.Position.RIGHT}>
              <B.AnchorButton
                id="map-basemap-control"
                icon="layer"
                active={activeMapSettingsTool === 'manageBasemap'}
                className={cs.mapIcon}
                onClick={() =>
                  setActiveMapSettingsTool(
                    activeMapSettingsTool === 'manageBasemap' ? null : 'manageBasemap'
                  )
                }
              />
            </B.Tooltip>
            <B.Tooltip content="Change overlays" position={B.Position.RIGHT}>
              <B.AnchorButton
                id="map-overlays-control"
                icon="layers"
                active={activeMapSettingsTool === 'manageLayers'}
                className={cs.mapIcon}
                onClick={(ev) => {
                  setActiveMapSettingsTool(
                    activeMapSettingsTool === 'manageLayers' ? null : 'manageLayers'
                  );

                  // Support turning on a hidden cool tile cost debugger overlay by
                  // holding the alt key down while clicking the layers icon
                  if (
                    profile &&
                    setShowCostDebugger &&
                    ev.altKey &&
                    userUtils.isUpstreamEmail(profile.get('email'))
                  ) {
                    setShowCostDebugger(!showCostDebugger);
                  }
                }}
              />
            </B.Tooltip>
            {canUseQuickMapVectorViewer && (
              <B.Tooltip content="View vector data" position={B.Position.RIGHT}>
                <B.AnchorButton
                  id="map-quick-map-vector-control"
                  icon="upload"
                  active={activeMapSettingsTool === 'quickMapVector'}
                  className={cs.mapIcon}
                  onClick={() =>
                    setActiveMapSettingsTool(
                      activeMapSettingsTool === 'quickMapVector' ? null : 'quickMapVector'
                    )
                  }
                />
              </B.Tooltip>
            )}
          </B.ButtonGroup>,
          this.mapSettingsControlButtonEl
        )}
      </React.Fragment>
    );
  }
}
